<template>
    <div>
    <b-modal
            id="modal-prevent-closing"
            ref="modal"
            :ok-title="'Ok'"
            :title="modalTitle"
            modal-class="edit-title"
            @hidden="resetModal"
            @ok="handleModalOk"
            size="lg"
            hide-footer
    >
        <b-row>
            <b-col>
                <video width="100%" :src="srcVideo"  controls="true"></video>
            </b-col>
        </b-row>
    </b-modal>
    </div>
</template>

<script>
  export default {
    data () {
      return {
        modalTitle: 'Tutorial',
        srcVideo: 'https://storage.googleapis.com/retextoar-publico/app/videos/tutorial_retextoar_novo_portal.mp4'
      };
    },
    methods: {
      resetModal () {
      },
      handleModalOk (bvModalEvt) {
        bvModalEvt.preventDefault();
        this.handleSubmit();
      },
      showModal () {
        this.$refs.modal.show();
      }
    }
  };
</script>
<style lang="scss" scoped>

</style>
